var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.members),function(item){return [_c('div',{key:item.title_id,staticClass:"vhtml",staticStyle:{"padding-top":"48px"},domProps:{"innerHTML":_vm._s(item[`title_${_vm.lang}`])}}),_c('div',{key:item.description_id,staticClass:"vhtml",domProps:{"innerHTML":_vm._s(item[`content_${_vm.lang}`])}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }